<template>
    <app-header-dropdown>
        <template slot="header">
            <span class="active">
                {{ $t('administrator.administrator') }}
            </span>
        </template>
        <template slot="dropdown">
            <b-dropdown-item v-if="showDropdownItem" to="/v2/administrator/hierarchy">
                {{ $t('administrator.hierarchy') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showOccupationGroupsDropdownItem" to="/v2/administrator/occupation-groups">
                {{ $t('administrator.occupationGroups') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showDropdownItem" to="/v2/administrator/users">
                {{ $t('administrator.users') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showDropdownItem" to="/v2/administrator/periods">
                {{ $t('administrator.periods') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showDropdownItem" to="/v2/administrator/tags">
                {{ $t('administrator.tags') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showDropdownItem" to="/v2/administrator/integrations">
                {{ $t('administrator.integrations') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showCustomersDropdownItem" to="/v2/administrator/customers">
                {{ $t('administrator.customers') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showCommitteesDropdownItem" to="/v2/administrator/committees">
                {{ $t('administrator.committees') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showNboxDropdownItem" to="/v2/n-box/list"> N-Box </b-dropdown-item>
            <b-dropdown-item v-if="showEnpsDropdownItem" to="/v2/administrator/enps">
                {{ $t('enps.enps') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showMoodPulseDropdownItem" to="/v2/administrator/mood-pulse">
                {{ $t('moodPulse.moodPulse') }}
            </b-dropdown-item>
        </template>
    </app-header-dropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
    name: 'DefaultAdministrationDropdown',
    props: ['currentUserPermissions', 'companyId'],
    components: {
        AppHeaderDropdown,
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser.user
        },
        isMainCompany() {
            return this.currentUser.company.id === 1
        },
        isAdmin() {
            return this.currentUser.role.name === 'administrator'
        },
        isLocalAdministrator() {
            return this.currentUser.role.name === 'local_administrator'
        },
        isGod() {
            return this.currentUser.role.name === 'god'
        },
        isValuesMaster() {
            return this.currentUser.is_values_master
        },
        hasValue() {
            return this.currentUser.has_modules.includes('has_value')
        },
        hasTarget() {
            return this.currentUser.has_modules.includes('has_goal')
        },
        hasKPI() {
            return this.currentUser.has_modules.includes('has_kpi')
        },
        hasAdminAccess() {
            return this.currentUser.has_admin_access
        },
        hasEnps() {
            return this.currentUser.has_modules.includes('has_enps')
        },
        hasQuiz() {
            return this.currentUser.has_modules.includes('has_quiz')
        },
        showEnpsDropdownItem() {
            return this.hasEnps && (this.isGod || this.isAdmin || this.isLocalAdministrator || this.hasAdminAccess)
        },
        showMoodPulseDropdownItem() {
            return this.hasQuiz && (this.isGod || this.isAdmin || this.isLocalAdministrator || this.hasAdminAccess)
        },
        showNboxDropdownItem() {
            return (
                (this.hasValue || this.hasTarget) &&
                (this.isGod || this.isAdmin || this.isValuesMaster || this.isLocalAdministrator)
            )
        },
        showCommitteesDropdownItem() {
            return (
                (this.hasValue || this.hasKPI || this.hasTarget) && (this.isAdmin || this.hasAdminAccess || this.isGod)
            )
        },
        showCustomersDropdownItem() {
            return this.isGod && this.isMainCompany
        },
        showOccupationGroupsDropdownItem() {
            return this.isGod || this.isAdmin || this.isValuesMaster || this.isLocalAdministrator || this.hasAdminAccess
        },
        showDropdownItem() {
            return this.isGod || this.isAdmin || this.isLocalAdministrator || this.hasAdminAccess
        },
    },
}
</script>
